<template>
  <div :class="cardClasses">
    <!-- Card Header (optional) -->
    <div v-if="hasHeader" :class="headerClasses">
      <slot name="header">
        <h3 v-if="title" class="text-base font-semibold m-0">{{ title }}</h3>
      </slot>
    </div>

    <!-- Card Body -->
    <div :class="bodyClasses">
      <slot></slot>
    </div>

    <!-- Card Footer (optional) -->
    <div v-if="hasFooter" :class="footerClasses">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseCard',
  props: {
    title: {
      type: String,
      default: null
    },
    variant: {
      type: String,
      default: 'default',
      validator: (value) => ['default', 'bordered', 'elevated', 'flat'].includes(value)
    },
    padding: {
      type: String,
      default: 'md',
      validator: (value) => ['none', 'sm', 'md', 'lg', 'xl'].includes(value)
    },
    rounded: {
      type: String,
      default: 'md',
      validator: (value) => ['none', 'sm', 'md', 'lg', 'xl'].includes(value)
    },
    hoverable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasHeader() {
      return this.$slots.header || this.title
    },
    hasFooter() {
      return this.$slots.footer
    },
    cardClasses() {
      return [
        'bg-white overflow-hidden border border-gray box-shadow-sm',
        this.variantClasses,
        this.roundedClasses,
        this.hoverable ? 'transition-shadow duration-300 hover:shadow-lg cursor-pointer' : ''
      ]
    },
    variantClasses() {
      const variants = {
        default: 'shadow-sm',
        bordered: 'border border-gray-200',
        elevated: 'shadow-md',
        flat: 'shadow-none'
      }
      return variants[this.variant]
    },
    roundedClasses() {
      const rounded = {
        none: 'rounded-none',
        sm: 'rounded-sm',
        md: 'rounded-md',
        lg: 'rounded-lg',
        xl: 'rounded-xl'
      }
      return rounded[this.rounded]
    },
    headerClasses() {
      return [
        'border-b border-gray-50 bg-gray-100',
        this.paddingClasses
      ]
    },
    bodyClasses() {
      return [
        this.paddingClasses
      ]
    },
    footerClasses() {
      return [
        'border-t border-gray-200 bg-gray-100',
        this.paddingClasses
      ]
    },
    paddingClasses() {
      const paddings = {
        none: 'p-0',
        sm: 'p-2',
        md: 'p-4',
        lg: 'p-6',
        xl: 'p-8'
      }
      return paddings[this.padding]
    }
  }
}
</script>
